import { Injectable } from '@angular/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { ToastComponent } from '@enginuity/core/organisms/toast/toast.component';
import { ToastData } from '@services/ui-services/models/toast-data';

export const ACCEPTED_TOAST_DATA: ToastData = {
  name: 'Accepted',
  message: 'accepted',
  info: 'successfully',
  time: '',
  toastIcons: {
    success: 'check',
    cancel: 'cancel',
    avatar: 'type',
  },
  type: 'success',
  State: 'default',
  primaryButton: false,
  secondayButton: false,
  showControls: false,
};

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  static forRoot(): import('@angular/core').Provider {
    throw new Error('Method not implemented.');
  }

  constructor(private toast: ToastrService) {}

  showToast(toastData: any): ActiveToast<any> {
    const activeToast: ActiveToast<any> = this.toast.show('', '', {
      toastComponent: ToastComponent,
    });
    Object.keys(toastData).forEach(key => {
      activeToast.toastRef.componentInstance[key] = toastData[key];
    });
    setTimeout(() => {
      this.dismissToast(activeToast);
    }, 3000);
    return activeToast;
  }

  dismissToast(activeToast: ActiveToast<any>) {
    this.toast.remove(activeToast.toastId); // This will remove the specific toast using the toastId
  }
}
